/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OrderShippingMethod } from './OrderShippingMethod';
import {
    OrderShippingMethodFromJSON,
    OrderShippingMethodFromJSONTyped,
    OrderShippingMethodToJSON,
    OrderShippingMethodToJSONTyped,
} from './OrderShippingMethod';

/**
 * 
 * @export
 * @interface ShippingStatistics
 */
export interface ShippingStatistics {
    /**
     * 
     * @type {OrderShippingMethod}
     * @memberof ShippingStatistics
     */
    shippingMethod?: OrderShippingMethod;
    /**
     * 
     * @type {number}
     * @memberof ShippingStatistics
     */
    amountNet?: number;
    /**
     * 
     * @type {number}
     * @memberof ShippingStatistics
     */
    amountGross?: number;
}

/**
 * Check if a given object implements the ShippingStatistics interface.
 */
export function instanceOfShippingStatistics(value: object): value is ShippingStatistics {
    return true;
}

export function ShippingStatisticsFromJSON(json: any): ShippingStatistics {
    return ShippingStatisticsFromJSONTyped(json, false);
}

export function ShippingStatisticsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShippingStatistics {
    if (json == null) {
        return json;
    }
    return {
        
        'shippingMethod': json['shippingMethod'] == null ? undefined : OrderShippingMethodFromJSON(json['shippingMethod']),
        'amountNet': json['amountNet'] == null ? undefined : json['amountNet'],
        'amountGross': json['amountGross'] == null ? undefined : json['amountGross'],
    };
}

export function ShippingStatisticsToJSON(json: any): ShippingStatistics {
    return ShippingStatisticsToJSONTyped(json, false);
}

export function ShippingStatisticsToJSONTyped(value?: ShippingStatistics | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'shippingMethod': OrderShippingMethodToJSON(value['shippingMethod']),
        'amountNet': value['amountNet'],
        'amountGross': value['amountGross'],
    };
}

